import { Controller as BaseController } from 'stimulus'
import I18n from '../../../javascript/i18n/index.js.erb'

export class Controller extends BaseController {
  static targets = ['compareButton', 'compareButtonSpan', 'helperText']
  static values = {
    noInteractions: Boolean,
    comparePath: String
  }

  selected = []

  connect() {
    if (this.noInteractionsValue) return

    this.updateHelperText(this.selected.length)
  }

  goToComparison() {
    const params = [
      ['left_document', encodeURIComponent(this.selected[0])],
      ['right_document', encodeURIComponent(this.selected[1])]
    ]

    const queryString = params.map(p => p.join('=')).join('&')

    window.location.assign(`${this.comparePathValue}?${queryString}`)
  }

  handleToggle(e) {
    if (e.detail.checked) {
      this.selected.push(e.detail.id)
    } else {
      this.selected.splice(this.selected.indexOf(e.detail.id), 1)
    }

    this.updateHelperText(this.selected.length)
  }

  updateHelperText(selectedCount) {
    this.compareButtonTarget.disabled = true
    this.compareButtonSpanTarget.title = I18n.t(
      'entities.show.overview.field.us_bill.bill_versions.disabled_button_tooltip'
    )

    if (selectedCount === 0) {
      this.helperTextTarget.innerHTML = I18n.t('entities.show.overview.field.us_bill.bill_versions.helper_text.no_bills')
      return
    }

    if (selectedCount === 2) {
      this.compareButtonTarget.disabled = false
      this.compareButtonSpanTarget.title = ''
    }

    this.helperTextTarget.innerHTML = I18n.t(
      'entities.show.overview.field.us_bill.bill_versions.helper_text.with_bills_html',
      { selected: this.selected.length }
    )
  }
}
